module.exports = __webpack_public_path__ + "media/images/icon__xco--rb-gray@2x-190398784597b9dc8a891ddec7b3939e.png";